// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__e01Pi","productName":"Table_productName__1lwUN"};